export const CATEGORY_RELEVANCY: string = "Category Relevancy";
export const ALL: string = "All";
export const TOP_25: string = "Top 25";
export const CURATED: string = "Curated";
export const ROWS_PER_CATEGORY: string = "Rows per Category";
export const NO_DATA_FOUND: string = "No data found";
export const CLEAR_ALL: string = "Clear All";
export const CATEGORY: string = "Category";
export const CATEGORY_TYPE: string = "Category Type";
export const CO_SOLD_CATEGORY: string = "Co-sold Category";
export const CO_SOLD_CATEGORY_TYPE: string = "Co-sold Category Type";
export const INVOICE_COUNT: string = "Invoice Count";
export const LOADING: string = "Loading...";
export const NO_CATEGORIES_FOUND: string = "No categories found";
export const NO_CO_SOLD_CATEGORIES_FOUND: string = "No co-sold categories found";
export const REVIEW: string = "Review";
export const LAST_UPDATED_ON: string = "Last Updated On";
export const ANALYSIS: string = "Analysis";
export const UNIFIED_ANALYSIS: string = "Unified Analysis";
export const ORDER_DATA_ANALYSIS: string = "Order Data Analysis";
export const TAXONOMY_ANALYSIS: string = "Taxonomy Analysis";
export const MANAGE_UNIFIED_SCORING: string = "Manage Unified Scoring";
export const SELECTED: string = "Selected";
export const ATTRIBUTE_OVERLAP: string = "Attribute Overlap";
export const UNIFIED_SCORING: string = "Unified Scoring";
export const COMPUTE: string = "Compute";
export const CREATE_COMPATIBILITY: string = "Create Compatibility";
export const VIEW_COMPATIBILITY: string = "View Compatibility";
export const COMPUTING_IN_PROGRESS: string = "Computing in Progress";
export const ESTIMATED_COMPLETION: string = "Estimated time of completion";
